import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"bread","clipPath":"url(#clip0_543_6550)"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M13.1877 4.68279C12.4649 3.96002 12.3732 3.67135 13.7817 3.15549C17.715 1.71493 22.2027 5.99442 21.1724 10.0545C20.5742 12.4121 18.9581 14.8672 16.9637 16.944C14.8869 18.9384 12.4318 20.5545 10.0742 21.1528C6.01408 22.183 1.73458 17.6953 3.17515 13.7621C3.69101 12.3536 3.97967 12.4453 4.70245 13.1681C2.42385 10.8895 6.32612 6.30648 8.47842 8.45878C6.32612 6.30648 10.9091 2.4042 13.1877 4.68279Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13.1875 4.68272L16.2564 7.75161M13.1875 4.68272C12.4647 3.95995 12.373 3.67128 13.7815 3.15542C17.7148 1.71486 22.2025 5.99435 21.1722 10.0545C20.574 12.412 18.9579 14.8671 16.9635 16.944C14.8867 18.9383 12.4316 20.5545 10.074 21.1527C6.01388 22.183 1.73439 17.6953 3.17495 13.762C3.69081 12.3535 3.97948 12.4452 4.70225 13.168M13.1875 4.68272C10.9089 2.40412 6.32592 6.30641 8.47822 8.45871M8.47822 8.45871L12.0138 11.9942M8.47822 8.45871C6.32592 6.30641 2.42365 10.8894 4.70225 13.168M4.70225 13.168L7.77114 16.2369","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Bread = Vue.extend<IconProps>({
  name: 'BreadIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'bread',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Bread;
